<template>  
  <modal max-width="1000" 
        :has-padding="false" 
        :value="value"
        @input="hidePlanModal" 
        content-class="marketing-plan-modal modal-device">    

    <div class="marketing-plan-modal-body">
      <div class="marketing-plan-modal-body-header">
        <button v-if="item"
                class="marketing-plan-modal-body-back"
                type="button"
                @click="emitBack">
          <i class=" mdi mdi-arrow-left pointer"></i>
        </button>

        <h1 class="marketing-plan-modal-body-title">{{ modalTitle }}</h1>
      </div>

      <marketing-plan-table v-model="selectedId"
                            :plansList="plansList"
                            :loading="loading"
                            :manage="manage"
                            @addPlan="hidePlanModal"
                            @cancelAddPlan="showPlanModal"
                            @changed="fetchPlans" />

      <v-card-actions v-if="item"
                      class="marketing-plan-modal-actions">
        <button class="btn btn-extra-round btn-primary btn-stretch"
                @click="openCreditConfirmModal">
          {{$t('message.marketingPlan.message.link')}}
        </button>
      </v-card-actions>
    </div>

    <sms-plan-credit-confirm-modal v-model="showPlanCreditConfirmModal"
                                   @confirmed="linkPlan" />
  </modal>                                 
</template>

<script>
import EventBus from "@packages/event-bus";
import SmsPlanCreditConfirmModal from "@components/sms/SmsPlanCreditConfirmModal";
import MarketingPlanTable from "@components/modules/marketing/plan/table/MarketingPlanTable";
import Modal from "@/components/generic/Modal";

export default {
  components: {
    MarketingPlanTable,
    SmsPlanCreditConfirmModal,
    Modal
  },
  data() {
    return {
      page: 0,
      plansList: [],
      selectedId: undefined,
      loading: false,
      showPlanCreditConfirmModal: false,
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: false,
    },
    manage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modalTitle() {
      return this.item ? this.$t('message.creditManagement.message.linkPlan') : this.$t('message.marketingPlan.message.managePlans');
    },
  },
  watch: {
    value: function (value) {
      if (value) {
        this.fetchPlans();
      }
    },
  },
  methods: {
    async fetchPlans() {
      this.loading = true;

      const plans = await this.$api.marketing.plan.list({
        page: this.page,
      });

      this.plansList = plans;

      this.loading = false;
    },
    emitInput(value) {
      this.$emit("input", value);
    },
    emitBack() {
      this.$emit("back");
    },
    hidePlanModal() {
      this.emitInput(false);
    },
    showPlanModal() {
      this.emitInput(true);
    },
    async linkPlan(addCreditToCurrentMonth) {
      const linkedPlan = await this.$api.marketing.account.plan.link({
        planId: this.selectedId,
        accountId: this.item.id,
        addCreditToCurrentMonth,
      });

      this.$emit("linked", linkedPlan);
    },
    openCreditConfirmModal() {
      if (this.selectedId) {
        this.showPlanCreditConfirmModal = true;
      } else {
        EventBus.$emit("show-message", {
          type: "ERROR",
          message: "Selecione o plano que você deseja vincular",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-plan-modal {
  .marketing-plan-modal-body {
    padding: 10px 20px;

    .marketing-plan-modal-body-header {
      position: relative;

      .marketing-plan-modal-body-back {
        position: absolute;
        font-size: 30px;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }

    .marketing-plan-modal-body-title {
      text-align: center;
      font-size: 30px;
      font-weight: 600;
      margin-bottom: 0;
    }

    .marketing-plan-modal-body-summary {
      display: flex;
      border-bottom: 1px solid #c4c4c4;
      border-radius: 0;

      .marketing-plan-modal-body-summary-item {
        flex: 1;
        text-align: center;
        border-right: 1px solid #c4c4c4;

        .marketing-plan-modal-body-summary-item-title {
          font-size: 22px;
          font-weight: 600;
        }

        &:last-child {
          border-right: none;
        }
      }
    }

    .marketing-plan-modal-body-credits {
      margin: 50px 0;
      text-align: center;
    }

    .marketing-plan-modal-body-actions {
      display: flex;
      justify-content: space-between;
    }
  }

  .marketing-plan-modal-actions {
    display: flex;
    justify-content: center;

    .btn {
      width: 200px;
    }
  }
}
</style>
